import styled from "@emotion/styled";

export const Main = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  background: rgba(0, 0, 0, 0.8);
  position: relative;
`;

export const ButtonClose = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  z-index: 10;

  svg {
    fill: #fff;
    width: 50px;
    height: 50px;
    filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.6));
  }
`;

export const Grid = styled.div`
  width: 100vw; /* Largura 100% da tela */
  height: 100vh; /* Altura 100% da tela */
  display: grid;
  grid-template-columns: 1fr 1fr; /* 2 colunas de tamanho igual */
  grid-template-rows: 50% 50%; /* 2 linhas de tamanho igual */
  gap: 0; /* Sem espaçamento entre os itens */
  position: absolute;
  top: 0;
  left: 0;
  margin: 0; /* Sem margem */
  overflow: hidden; /* Garante que nada ultrapasse */
`;

export const Video = styled.video`
  width: 100%; !important;
  height: 100% !important;
  object-fit: cover;
  background-color: black;
`;

export const Loading = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    font-size: 24px;
    color: #fff;
  }
`;
